import {Card2Type} from '../@types'

export const getCallTrackingCardsConfig = (): Pick<Card2Type, 'body'>[] => [
    { body: { text: 'CallTrackingCards 0', description: 'description - 0', total: 0 } },
    { body: { text: 'CallTrackingCards 1', description: 'description - 1', total: 0 } },
    { body: { text: 'CallTrackingCards 2', description: 'description - 2', total: 0 } },
    { body: { text: 'CallTrackingCards 3', description: 'description - 3', total: 0 } },
];

export const getWebFormsCardsConfig = (): Pick<Card2Type, 'body'>[] => [
    { body: { text: 'WebFormsCards 0', description: 'description - 0', total: 0 } },
    { body: { text: 'WebFormsCards 1', description: 'description - 1', total: 0 } },
    { body: { text: 'WebFormsCards 2', description: 'description - 2', total: 0 } },
    { body: { text: 'WebFormsCards 3', description: 'description - 3', total: 0 } },
];

export const getSupportCardsConfig = (): Pick<Card2Type, 'body'>[] => [
    { body: { text: 'SupportCards 0', description: 'description - 0', total: 0 } },
    { body: { text: 'SupportCards 1', description: 'description - 1', total: 0 } },
];

export const getWebsiteUpdatesCardsConfig = (): Pick<Card2Type, 'body'>[] => [
    { body: { text: 'SupportCards 0', description: 'description - 0', total: 0 } },
    { body: { text: 'SupportCards 1', description: 'description - 1', total: 0 } },
    { body: { text: 'SupportCards 1', description: 'description - 2', total: 0 } },
    { body: { text: 'SupportCards 1', description: 'description - 3', total: 0 } },
    { body: { text: 'SupportCards 0', description: 'description - 4', total: 0 } },
    { body: { text: 'SupportCards 1', description: 'description - 5', total: 0 } },
];